<template>
    <modal dialog="modal-lg" class="dark-top" :header="false" :customClass="'heightAuto'" :footer="true">
        <div slot="body" class="p-4">

            <h2 class="text-center mb-3">Cancellation request</h2>

            <p class="mb-3">
                Please type a reason for this cancellation request. We will notify customer service with this.
            </p>

            <div class="form-group row">
                <div class="col-sm-12">
                    <textarea rows="6" placeholder="e.g. weather conditions." v-model="getSelectedReservation.cancelationNote"></textarea>
                </div>
            </div>

        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="save" :disabled="isInvalidValid">Continue</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'
    import Modal from './Modal'

    export default {
        mixins:[
            reservationsMixin
        ],
        mounted: function () {
            // console.log('mounted', this.getSelectedReservation);
            if(!this.getSelectedReservation.cancelationNote){
                this.$set(this.getSelectedReservation, 'cancelationNote', null)
            }

            this.reservation = this.getSelectedReservation
        },
        data: function() {
            return {
                isDisabled: true,
                updatedForm: null,
                reservation: null
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedReservation'
            ]),
            isInvalidValid: function () {
                return this.getSelectedReservation.cancelationNote == '' || this.getSelectedReservation.cancelationNote == null ||  typeof this.getSelectedReservation.cancelationNote == "undefined"
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
            ]),
            cancel: function() {
                this.closeModal();
            },
            save: function() {
                this.setReservationToCancel(false)
                this.closeModal();
            }
        },
        components: {
            Modal,
        }
    }
</script>



// WEBPACK FOOTER //
// ReservationCancelReason.vue?e03440b8